import { useEffect, useState } from 'react'

const useResetState = (initialValue, reset) => {
  const [value, setValue] = useState(initialValue)
  useEffect(() => {
    if (reset) {
      setValue(initialValue)
    }
  }, [reset])
  return [value, setValue]
}

export default useResetState
